import { render, staticRenderFns } from "./userBlocked.vue?vue&type=template&id=e5cc858e&"
import script from "./userBlocked.vue?vue&type=script&lang=js&"
export * from "./userBlocked.vue?vue&type=script&lang=js&"
import style0 from "./userBlocked.vue?vue&type=style&index=0&id=e5cc858e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports